/**
 * Cliente HTTP das capturas da mesa anexadas ao laudo (E36.F4). // ux-neutrality:allow doc-comment
 *
 * Espelha apps/api/types/laudo_attachment.py e apps/api/runtime/laudo_attachments.py. // ux-neutrality:allow doc-comment
 *
 * A captura é client-side: a mesa exporta a vista corrente como PNG (fiel ao // ux-neutrality:allow doc-comment
 * que a perita vê — sobreposição, filtros, anotações, zoom) e sobe via // ux-neutrality:allow doc-comment
 * multipart. O checklist "Conteúdo do laudo" controla `include_in_laudo`; o // ux-neutrality:allow doc-comment
 * render embute as selecionadas na seção da contestada correspondente. // ux-neutrality:allow doc-comment
 */
import type { AxiosInstance } from 'axios';

export interface LaudoAttachmentData {
  id: string;
  case_analysis_id: string;
  label: string;
  include_in_laudo: boolean;
  usuario_id: string | null;
  created_at: string;
}

export interface LaudoAttachmentUpdateData {
  label?: string;
  include_in_laudo?: boolean;
}

function attachmentsPath(caseId: string, analysisId: string): string {
  return `/casos/${caseId}/analyses/${analysisId}/laudo-attachments`;
}

export function getLaudoAttachmentBlobUrl(
  caseId: string,
  analysisId: string,
  attachmentId: string,
): string {
  return `${attachmentsPath(caseId, analysisId)}/${attachmentId}/blob`;
}

export async function listLaudoAttachments(
  client: AxiosInstance,
  caseId: string,
  analysisId: string,
): Promise<LaudoAttachmentData[]> {
  const { data } = await client.get<LaudoAttachmentData[]>(attachmentsPath(caseId, analysisId));
  return data;
}

export async function createLaudoAttachment(
  client: AxiosInstance,
  caseId: string,
  analysisId: string,
  label: string,
  image: Blob,
): Promise<LaudoAttachmentData> {
  const form = new FormData();
  form.append('file', image, 'captura.png');
  form.append('label', label);
  const { data } = await client.post<LaudoAttachmentData>(
    attachmentsPath(caseId, analysisId),
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return data;
}

export async function updateLaudoAttachment(
  client: AxiosInstance,
  caseId: string,
  analysisId: string,
  attachmentId: string,
  payload: LaudoAttachmentUpdateData,
): Promise<LaudoAttachmentData> {
  const { data } = await client.patch<LaudoAttachmentData>(
    `${attachmentsPath(caseId, analysisId)}/${attachmentId}`,
    payload,
  );
  return data;
}

export async function deleteLaudoAttachment(
  client: AxiosInstance,
  caseId: string,
  analysisId: string,
  attachmentId: string,
): Promise<void> {
  await client.delete(`${attachmentsPath(caseId, analysisId)}/${attachmentId}`);
}

export async function fetchLaudoAttachmentBlob(
  client: AxiosInstance,
  caseId: string,
  analysisId: string,
  attachmentId: string,
): Promise<Blob> {
  const { data } = await client.get<Blob>(
    getLaudoAttachmentBlobUrl(caseId, analysisId, attachmentId),
    { responseType: 'blob' },
  );
  return data;
}
